import React, { Fragment, Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import { withStyles } from '@material-ui/core/styles';
import { ChevronDownIcon } from '../themes/icons/ChevronDownIcon';
import { ChevronUpIcon } from '../themes/icons/ChevronUpIcon';

const styles = {
  listItem: {
    paddingLeft: '1.25rem',
    paddingRight: '1.75rem',
    'white-space': 'nowrap'
  },
  listItemText: {
    paddingLeft: '8px',
    paddingRight: '8px',
    fontSize: '14px',
    minWidth: 'auto'
  },
  sidebarIsOpen: {
    paddingLeft: 0,
    transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
  },
  sidebarIsClosed: {
    paddingLeft: 0,
    transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
  },
  iconContainer: {
    width: '20px',
    minWidth: '20px',
    minHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    minWidth: '14px',
    paddingRight: 0
  },
  listItemIcon: {
    fontSize: '16px',
    minWidth: '20px',
    paddingRight: 0
  },
  dividerWhenMenuCollapsed: {
    width: '250%'
  },
  dividerWhenMenuOpen: {
    width: '100%'
  }
};

class SubMenu extends Component {
  render() {
    const {
      handleToggle,
      sidebarIsOpen,
      isOpen,
      name,
      icon,
      classes,
      children
    } = this.props;

    const collapsedTextHidden = {
      visibility: 'hidden'
    };

    return (
      <Fragment>
        <ListItem
          dense
          button
          onClick={handleToggle}
          className={classes.listItem}
        >
          <div className={classes.iconContainer}>
            <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
          </div>
          <ListItemText
            secondaryTypographyProps={
              sidebarIsOpen ? {} : { style: collapsedTextHidden }
            }
            primaryTypographyProps={
              sidebarIsOpen ? {} : { style: collapsedTextHidden }
            }
            inset
            primary={isOpen ? name : ''}
            secondary={isOpen ? '' : name}
            className={classes.listItemText}
          />
          <ListItemIcon className={classes.listItemIcon}>
            {sidebarIsOpen &&
              (isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />)}
          </ListItemIcon>
        </ListItem>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Divider
            className={
              sidebarIsOpen
                ? classes.dividerWhenMenuOpen
                : classes.dividerWhenMenuCollapsed
            }
          />
          <List
            dense
            component="div"
            disablePadding
            data-testid="sidebar"
            className={
              sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed
            }
          >
            {children}
          </List>
          <Divider
            className={
              sidebarIsOpen
                ? classes.dividerWhenMenuOpen
                : classes.dividerWhenMenuCollapsed
            }
          />
        </Collapse>
      </Fragment>
    );
  }
}

export default withStyles(styles)(SubMenu);
